export const targetBlank = (href) => ({ href, rel: 'noopener noreferrer', target: '_blank' });
